// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.storage.claimreleaselistingtransactionlog.ReleaseListingReasonType

export enum ReleaseListingReasonType {
  CLAIMED_BY_MISTAKE = 'CLAIMED_BY_MISTAKE',
  COMPANY_NOT_LONGER_MANAGE = 'COMPANY_NOT_LONGER_MANAGE',
  USER_NOT_LONGER_MANAGE = 'USER_NOT_LONGER_MANAGE',
}

export const ReleaseListingReasonType_values = [
  ReleaseListingReasonType.CLAIMED_BY_MISTAKE,
  ReleaseListingReasonType.COMPANY_NOT_LONGER_MANAGE,
  ReleaseListingReasonType.USER_NOT_LONGER_MANAGE,
] as const;
